// extracted by mini-css-extract-plugin
export default {"textBlock":"textBlock___a2d44939ce2b42ba","audio":"audio___b8c53db788f9b654","video":"video___ba447472d9a88356","additionalContent":"additionalContent___bfac140d013e986c"};